import Axios from 'axios'
import Swal from 'sweetalert2'
import server from 'util/Servidor'
import { sessionCaducada } from 'util/funciones'
import Storage from 'util/store/Storage'
import { btnVerDetalles } from './AsignacionParametros.models'

export const TIPOS = [
  { label: '1 - text', value: 1 },
  { label: '2 - boolean', value: 2 },
  { label: '3 - number', value: 3 },
  { label: '4 - JSON', value: 4 }
  /* { label: 5, value: 5 } */
]

export const VALOR_BOOLEAN = [
  { label: 'S - TRUE', value: 'S' },
  { label: 'N - FALSE', value: 'N' }
]

export const getEquiposByEmpresasID = async id => {
  return new Promise(function (resolve, reject) {
    Axios.get(server.host + server.puertoCentury + '/api/equipo/empresaall/' + id, {
      headers: { Authorization: server.obtenerToken() }
    })
      .then(res => {
        if (res.status === server.responseOK) {
          const datos = res.data
          resolve(datos)
        } else if (
          res.status === server.responseSesionCaducada ||
          res.status === server.responseErrorServidor
        ) {
          sessionCaducada()
        }
      })
      .catch(err => {
        console.error(err)
        reject(err)
      })
  })
}

export const obtenerWacherParametrosEquipo = async id => {
  return new Promise(function (resolve, reject) {
    Axios.get(server.host + server.puertoCentury + '/api/wacher-parametros/' + id, {
      headers: { Authorization: server.obtenerToken() }
    })
      .then(res => {
        if (res.status === server.responseOK) {
          const datos = res.data
          resolve(datos)
        } else if (
          res.status === server.responseSesionCaducada ||
          res.status === server.responseErrorServidor
        ) {
          sessionCaducada()
        }
      })
      .catch(err => {
        console.error(err)
        reject(err)
      })
  })
}

export const mostrarDialogDetalles = (mostrar, equipo) => {
  Storage.dispatch({
    type: 'FORMULARIO_EXTERNO',
    formularioExterno: mostrar,
    metodoFormulario: 'get',
    formularioId: equipo
  })
}

export const guardarWacherParametro = async (param) => {
  if (param.tipo === 4) {
    try {
      JSON.parse(param.valor)
    } catch (error) {
      throw Error('Formato JSON incorrecto')
    }
  }
  const data = {
    notificarEquipos: true,
    identificadorEquipo: param.equipos_id,
    parametros: [
      {
        empresas_id: param.empresas_id,
        codigo: param.codigo,
        tipo: param.tipo,
        valor: param.valor,
        atributos: param.atributos
      }
    ]
  }
  return Axios.post(server.host + server.puertoCentury + '/api/wacher-parametros', data, {
    headers: { Authorization: server.obtenerToken() },
    'Content-Type': 'application/json'
  })
}
export const validarFormulario = form => {
  if (form.codigo === undefined || form.codigo === '') {
    Swal.fire({
      title: '',
      text: 'Se requiere un código.',
      icon: 'warning'
    })
    return false
  }
  if (form.tipo === undefined || form.tipo === {} || form.tipo.value === 0) {
    Swal.fire({
      title: '',
      text: 'Seleccione un tipo.',
      icon: 'warning'
    })
    return false
  }
  if (form.valor === undefined || form.valor === '') {
    Swal.fire({
      title: '',
      text: 'Ingrese un valor valido.',
      icon: 'warning'
    })
    return false
  }
  if (form.controlador.value === 0) {
    Swal.fire({
      title: '',
      text: 'Seleccione un controlador',
      icon: 'warning'
    })
    return false
  }
  return true
}

export const asignarParamsDesdeEquipo = params => {
  const equipo = Storage.getState().formularioId

  const data = {
    identificadorEquipo: equipo.id,
    parametros: params
  }

  return new Promise((resolve, reject) => {
    Axios.post(server.host + server.puertoCentury + '/api/wacher-parametros', data, {
      headers: { Authorization: server.obtenerToken() },
      'Content-Type': 'application/json'
    })
      .then(res => {
        if (res.status === server.responseSucces) {
          Swal.fire({
            title: 'OK!',
            text: '¡WACHERPARAMETROS AGREGADOS CORRECTAMENTE!',
            icon: 'success'
          }).then(value => {
            if (value.value) {
              btnVerDetalles(equipo)
                Storage.dispatch({
                  type: 'ACTUALIZACION_DATOS',
                  actualizarvista: true
                })
                Storage.dispatch({
                  type: 'MOSTRAR_OCULTAR',
                  mostrar: false
                })
            }
          })
        } else if (res.status === server.responseSesionCaducada) {
          sessionCaducada()
        } else {
          Swal.fire('Fallo al guardar', 'Por favor verifique los datos', 'warning')
        }
      })
      .catch(err => {
        console.error(err)
        Swal.fire({
          title: 'ERROR',
          text: 'No se guardaron los paramtros. Verifique los datos.',
          icon: 'error'
        })
        reject(err, undefined)
      })
  })
}

export const obtenerIslasEstaciones = async (estacionId) => {
  return Axios.post(server.host + server.puertoCentury + '/api/equipo/obtener-equipos-empresas', { estacion_id: estacionId }, {
    headers: { Authorization: server.obtenerToken() },
    'Content-Type': 'application/json'
  })
}
